import { render, staticRenderFns } from "./RentalClaims.vue?vue&type=template&id=9b40b7a2&scoped=true"
import script from "./RentalClaims.vue?vue&type=script&lang=js"
export * from "./RentalClaims.vue?vue&type=script&lang=js"
import style0 from "./RentalClaims.vue?vue&type=style&index=0&id=9b40b7a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b40b7a2",
  null
  
)

export default component.exports